import React, { Component, Fragment } from 'react'
import { Absolute as AbsoluteComponent } from '../primitives'
import { Ref } from 'semantic-ui-react'

const Absolute = AbsoluteComponent.extend`
  width: 100%;
  z-index: 1;
  @media (min-width: 65em) {
    width: fit-content;
  }
`

export default class Dropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showDropdown: false
    }
  }

  toggleDropdown = () => {
    this.setState({ showDropdown: !this.state.showDropdown })
  }

  handleClick = e => {
    if (
      !this.buttonNode ||
      this.buttonNode.contains(e.target) ||
      !this.contentNode ||
      this.contentNode.contains(e.target)
    ) {
      return
    } else {
      this.setState({
        showDropdown: false
      })
    }
  }

  componentWillMount() {
    document.addEventListener('click', this.handleClick, false)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick, false)
  }

  render() {
    const Children = React.Children.toArray(this.props.children)

    const toggleButton = React.cloneElement(Children[0], {
      onClick: this.toggleDropdown
    })

    const content = Children[1] || null

    return (
      <Fragment>
        <Ref innerRef={el => (this.buttonNode = el)}>{toggleButton}</Ref>
        {this.state.showDropdown && (
          <Ref innerRef={el => (this.contentNode = el)}>
            <Absolute>{content}</Absolute>
          </Ref>
        )}
      </Fragment>
    )
  }
}
